import * as React from 'react';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { browserHistory } from 'react-router';
import * as i18n from 'i18next';
import Slider from 'react-slick';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import renderIcon from 'helpers/renderIcon';
import { formatCurrency } from 'helpers/common';

interface IOwnProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
	isDragging?: boolean;
}

interface IProps extends IOwnProps {}

interface IState {
	maxElWidth: number;
}

function CustomSlickArrow(props) {
	const { classToAdd, onClick, children } = props;
	return (
		<div className={'slick-arrow ' + classToAdd} onClick={onClick}>
			{children}
		</div>
	);
}

let oldWidth = 1400;

class ViewType7 extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			maxElWidth: null,
		};

		this.onResize = this.onResize.bind(this);
		this.handleNavigate = this.handleNavigate.bind(this);
		this.setMaxElWidth = this.setMaxElWidth.bind(this);
		this.slidesSetter = this.slidesSetter.bind(this);
	}
	sectionRef = React.createRef<HTMLDivElement>();
	slidesRef = 8; // to mitigate the issue of eventlitstener (as it uses the value it received on load)
	slidesToScrlRef = 1; // to mitigate the issue of eventlitstener (as it uses the value it received on load)

	public componentDidMount() {
		window.addEventListener('resize', this.onResize);
		this.onResize();
	}
	public componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	private setMaxElWidth() {
		const section = this.sectionRef.current;
		if (section) {
			const sectionWidth = section.getBoundingClientRect().width;
			const clientWidth = document.documentElement.clientWidth;
			// shrinking
			if (sectionWidth >= clientWidth - 30 && oldWidth > clientWidth - 30) {
				this.setState({
					maxElWidth: clientWidth && clientWidth <= 1400 ? clientWidth - 30 : 1400,
				});
				oldWidth = clientWidth - 30;
				return;
			}
			// expanding
			if (sectionWidth <= clientWidth - 30 && oldWidth < clientWidth - 30) {
				this.setState({
					maxElWidth: clientWidth && clientWidth <= 1400 ? clientWidth - 30 : 1400,
				});
				oldWidth = clientWidth - 30;
				return;
			}
			// initial
			this.setState({
				maxElWidth: clientWidth - 30 < 1400 ? clientWidth - 30 : 1400,
			});
			oldWidth = clientWidth - 30;
		}
	}

	private slidesSetter(slides: number, slidesToScrl: number) {
		this.slidesRef = slides;
		this.slidesToScrlRef = slidesToScrl;
	}

	private onResize() {
		this.setMaxElWidth();
		const maxWidth = this.state.maxElWidth || document.documentElement.clientWidth - 30;
		const slides = this.slidesRef;
		if (maxWidth > 1300 && slides !== 6) {
			this.slidesSetter(6, 1);
		} else if (maxWidth <= 1300 && maxWidth > 1150 && slides !== 5) {
			this.slidesSetter(5, 1);
		} else if (maxWidth <= 1150 && maxWidth > 1000 && slides !== 4) {
			this.slidesSetter(4, 1);
		} else if (maxWidth <= 1000 && maxWidth > 500 && slides !== 3) {
			this.slidesSetter(3, 3);
		} else if (maxWidth <= 500 && slides !== 2) {
			this.slidesSetter(2, 2);
		}
	}

	private handleNavigate(redirectPath: string) {
		if (redirectPath) {
			browserHistory.push(redirectPath);
		}
	}

	public render() {
		///////////////////////////////////////////////////
		// Slider settings
		///////////////////////////////////////////////////
		const settings = {
			dots: false,
			infinite: true,
			speed: 674,
			slidesToShow: this.slidesRef ? this.slidesRef : 6,
			slidesToScroll: this.slidesToScrlRef ? this.slidesToScrlRef : 1,
			arrows: true,
			prevArrow: <CustomSlickArrow classToAdd="slick-prev">{renderIcon('left')}</CustomSlickArrow>,
			nextArrow: <CustomSlickArrow classToAdd="slick-next">{renderIcon('right')}</CustomSlickArrow>,
			autoplay: false,
			easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
		};
		let imageUrl = '';
		const redirectUrl = {
			1: '',
			2: '',
			3: '',
			4: '',
			5: '',
			6: '',
			7: '',
			8: '',
			9: '',
			10: '',
			11: '',
			12: '',
			13: '',
			14: '',
			15: '',
			16: '',
		};
		let productTitle = '';
		let productPrice = undefined;
		let shopTitle = '';
		///////////////////////////////////////////////////

		const renderedItems = () => {
			return this.props.section.items
				.slice(1)
				.filter(
					(item) =>
						item.elements &&
						item.elements.length &&
						item.elements[0] &&
						(item.elements[0] as ISectionImageElement).imageUrl,
				)
				.map((x, index) => {
					const itemImageUrl = (x.elements[0] as ISectionImageElement).imageUrl;
					imageUrl = itemImageUrl ? itemImageUrl : '';

					const item = x.elements[1] as ISectionTextElement;
					const itemRedirectUrl = item?.redirectUrl;
					redirectUrl[index] = itemRedirectUrl ? itemRedirectUrl : '';
					productTitle = item?.text ? item.text : '';

					const shopInfo = x.elements[2] as ISectionTextElement;
					shopTitle = shopInfo?.text ? shopInfo.text : '';

					const priceInfo = x.elements[3] as ISectionTextElement;
					productPrice = priceInfo?.text ? parseInt(priceInfo.text) : undefined;

					const currencyKeyElem = x.elements?.[5] as ISectionTextElement;
					const currencyKey = currencyKeyElem?.text ? parseInt(currencyKeyElem.text) : undefined;

					return (
						<div key={index}>
							<div
								className={`image-container d-flex ${redirectUrl[index] ? 'pointer' : ''}`}
								onClick={() => this.handleNavigate(redirectUrl[index])}
								style={{ backgroundImage: `url(${imageUrl})` }}
							>
								<p className="p14 white">{productTitle}</p>
								<p className="p14 bold white">{formatCurrency(currencyKey, productPrice)}</p>
								<div className="gradient" />
							</div>
							<p className="p12">{shopTitle}</p>
						</div>
					);
				});
		};

		return (
			<div className="row">
				<div className="col-lg-12">
					<div
						className="portalPageSectionType7"
						style={{ maxWidth: this.state.maxElWidth ? this.state.maxElWidth : 'auto' }}
						ref={this.sectionRef}
					>
						<h3>{i18n.t('PortalPage_Section_Manage_SectionViewTitle_StaffPick')}</h3>
						<div className="sliderContainer">
							<Slider {...settings}>{renderedItems()}</Slider>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType7 };
